import { createApp } from '@app/adapters/create-app'
import FirmInbox from '../../screens/inbox/components/firm-inbox'
import createFirmInboxStore from '../../screens/inbox/store/firm-inbox'
import api from '@app/application/communication/sections/communication/api/index'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'
import * as mutationTypes from '../../screens/inbox/store/mutation-types'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='firm-inbox']").each(function () {
    const endpointParams = {
      firmId: Silverfin.currentFirmId,
    }

    const store = createFirmInboxStore(
      endpointParams,
      api.getNotificationsCommunication
    )

    for (const section of ['unread', 'read']) {
      const value = this.dataset[`${section}Sort`]
      if (value) {
        store.commit(mutationTypes.SET_INBOX_SORT, { section, value })
      }
    }

    const firmInboxApp = createApp(FirmInbox)

    firmInboxApp.use(store)
    firmInboxApp.mount(this)

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: false,
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })

      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
